import createSvgIcon from '../createSvgIcon';
export default createSvgIcon(
  <g fill="none" fillRule="evenodd">
    <path
      d="M15.476 12.932l.414-2.874h-2.593V8.193c0-.786.362-1.552 1.524-1.552H16V4.194S14.93 4 13.907 4c-2.136 0-3.533 1.376-3.533 3.868v2.19H8v2.874h2.374v6.947a8.873 8.873 0 002.923 0v-6.947h2.179z"
      fill="#4267B2"
    />
    <path fill="none" d="M0 0h24v24H0z" fillOpacity="0" />
  </g>,
  'FacebookIcon',
  '',
  false,
);
